import { createElem, optionRow, addElement, createH3Label } from './util/form_fields.js';

$( document ).on('turbo:load', function () {
    if ($('#validations').length > 0) {
        if($('.validations_row').length > 0){
            $('#validations').collapse('show');
        }
        $('#add_validation').click(function () {
            if ($('#h3_validations').length <= 0) {
                var h3 = createH3Label('Validations', 'h3_validations');
                addElement('validations', h3);
            }
            var validationsCount = $('#validations').data('validations_count');

            var wrapper = optionRow();

            var row = createElem('div', ['row']);
            $(row).addClass('validations_row');

            var validationType = createElem('div', ['col-sm-3']);
            var value = createElem('div', ['col-sm-4']);
            var message = createElem('div', ['col-sm-4']);

            var validationTypeLabel = createElem('label', null, {'for': 'custom_form_field_custom_form_field_validations_attributes_' + validationsCount + '_validation_type'});
            validationTypeLabel.innerText = 'Validation type';

            var validationsTypeHelpIcon = createElem('i', ['glyphicon', 'glyphicon-question-sign'], {'data-toggle': 'tooltip', 'data-placement': 'top', 'title': $('#validations').data('validation-type-help')});

            var validationTypeSelect = createElem('select', ['form-control', 'validation_select']);
            validationTypeSelect.name = 'custom_form_field[custom_form_field_validations_attributes][' + validationsCount + '][validation_type]';
            validationTypeSelect.id = 'custom_form_field_custom_form_field_validations_attributes_' + validationsCount + '_validation_type';

            var validationTypes = $('#validations').data('validation_types');

            for (var i = 0; i < validationTypes.length; i++) {
                var option = createElem('option');
                option.value = validationTypes[i];
                option.text = validationTypes[i];
                $(validationTypeSelect).append(option);
            }

            var valueLabel = createElem('label', null, {'for': 'custom_form_field_custom_form_field_validations_attributes_' + validationsCount + '_value'});
            valueLabel.innerText = 'Value';

            var validationsValueHelpIcon = createElem('i', ['glyphicon', 'glyphicon-question-sign'], {'data-toggle': 'tooltip', 'data-placement': 'top', 'title': $('#validations').data('validation-value-help')});

            var valueInput = createElem('input', ['form-control', 'validation_value_field']);
            valueInput.type = 'text';
            valueInput.name = 'custom_form_field[custom_form_field_validations_attributes][' + validationsCount + '][value]';
            valueInput.id = 'custom_form_field_custom_form_field_validations_attributes_' + validationsCount + '_value';

            var messageLabel = createElem('label', null, {'for': 'custom_form_field_custom_form_field_validations_attributes_' + validationsCount + '_message'});
            messageLabel.innerText = 'Message';

            var validationsMessageHelpIcon = createElem('i', ['glyphicon', 'glyphicon-question-sign'], {'data-toggle': 'tooltip', 'data-placement': 'top', 'title': $('#validations').data('validation-message-help')});

            var messageInput = createElem('input', ['form-control', 'validation_message_field']);
            messageInput.type = 'text';
            messageInput.name = 'custom_form_field[custom_form_field_validations_attributes][' + validationsCount + '][message]';
            messageInput.id = 'custom_form_field_custom_form_field_validations_attributes_' + validationsCount + '_message';

            $(validationType).append(validationTypeLabel);
            $(validationType).append(' ');
            $(validationType).append(validationsTypeHelpIcon);
            $(validationType).append(validationTypeSelect);
            $(row).append(validationType);

            $(value).append(valueLabel);
            $(value).append(' ');
            $(value).append(validationsValueHelpIcon);
            $(value).append(valueInput);
            $(row).append(value);

            $(message).append(messageLabel);
            $(message).append(' ');
            $(message).append(validationsMessageHelpIcon);
            $(message).append(messageInput);
            $(row).append(message);
            $(wrapper).append(row);
            $('#validations_container').append(wrapper);
            $('#validations').data('validations_count', validationsCount + 1);

        });
    }
});
